import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
    UrlTree,

} from '@angular/router';
import {AuthService} from "../services/auth.service";
import {NavService} from '../services/nav.service';

@Injectable({ providedIn: 'root' })
export class HomeClassicGuard implements CanActivate {
    constructor(private authService: AuthService,
                private nav: NavService,
                private router: Router,
                ) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        if (this.authService.getUserCompanyDashboard() === 'classic' || this.authService.getUserType() === 'coach') {
            return true;
        } else {
            return this.router.createUrlTree(this.nav.getHomeCommand());
        }
    }
}
